import React from 'react';
import { Row, Col, Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import MaskedInput from 'react-text-mask';

// ── Inputs enmascarados ──────────────────────────────────────────────────────
function CreditCardInput({ inputRef, ...other }) {
  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      showMask
      guide={false}
    />
  );
}

function ExpiryInput({ inputRef, ...other }) {
  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/]}
      showMask
      guide={false}
    />
  );
}

// ── Componente principal ─────────────────────────────────────────────────────
const CreditCardForm = ({
  creditCardDetails,
  setCreditCardDetails,
  identificationTypes,
  errors,
  onCardNumberChange
}) => {
  const { t } = useTranslation();

  const cardPlaceholders = { name: t('NAME LAST NAME') };
  const cardLocale = { valid: '' };

  const renderIdentificationTypes = () =>
    identificationTypes.map(e => (
      <Select.Option key={e.id} value={e.id}>
        {e.name}
      </Select.Option>
    ));

  return (
    <Row type="flex" align="top" justify="start" className="content-row">
      {/* Formulario */}
      <Col className="card" xs={16} sm={16} md={16} lg={16} xl={16}>
        <Form>
          <Row type="flex">
            <Col xs={24}>
              <p className="title-form">{t('Card number')}</p>
              <Form.Item
                validateStatus={!!errors['creditCardNumber'] && 'error'}
                help={errors['creditCardNumber']}
              >
                <CreditCardInput
                  id="number"
                  className="ant-input"
                  placeholder={t('Name as it appears on the card')}
                  autoComplete="cc-number"
                  value={creditCardDetails.number}
                  onFocus={() => setCreditCardDetails(p => ({ ...p, focused: 'number' }))}
                  onChange={e => onCardNumberChange(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <p className="title-form">{t('Name')}</p>
              <Form.Item validateStatus={!!errors['name'] && 'error'} help={errors['name']}>
                <Input
                  placeholder={t('Name')}
                  autoComplete="cc-name"
                  value={creditCardDetails.name}
                  onFocus={() => setCreditCardDetails(p => ({ ...p, focused: 'name' }))}
                  onChange={e => setCreditCardDetails(p => ({ ...p, name: e.target.value }))}
                />
              </Form.Item>
            </Col>

            <Col xs={11}>
              <p className="title-form">{t('Date expiry')}</p>
              <Form.Item
                validateStatus={!!errors['expiry'] && 'error'}
                help={errors['expiry']}
                style={{ paddingRight: '15px' }}
              >
                <ExpiryInput
                  id="expiry"
                  className="ant-input"
                  placeholder="MM/AA"
                  autoComplete="cc-exp"
                  value={creditCardDetails.expiry}
                  onFocus={() => setCreditCardDetails(p => ({ ...p, focused: 'expiry' }))}
                  onChange={e => setCreditCardDetails(p => ({ ...p, expiry: e.target.value }))}
                />
              </Form.Item>
            </Col>

            <Col xs={13}>
              <p className="title-form" style={{ paddingLeft: '15px' }}>
                {t('Security code')}
              </p>
              <Form.Item
                validateStatus={!!errors['cvc'] && 'error'}
                help={errors['cvc']}
                style={{ paddingLeft: '15px' }}
              >
                <Input
                  id="cvc"
                  placeholder={t('Security code')}
                  autoComplete="cc-csc"
                  value={creditCardDetails.cvc}
                  onFocus={() => setCreditCardDetails(p => ({ ...p, focused: 'cvc' }))}
                  onChange={e => setCreditCardDetails(p => ({ ...p, cvc: e.target.value }))}
                />
              </Form.Item>
            </Col>

            <Col xs={6}>
              <p className="title-form">{t('Document type')}</p>
              <Form.Item
                validateStatus={!!errors['documentType'] && 'error'}
                help={errors['documentType']}
              >
                <Select
                  placeholder={t('Document type')}
                  style={{ width: '200px' }}
                  value={creditCardDetails.documentType}
                  onFocus={() => setCreditCardDetails(p => ({ ...p, focused: 'number' }))}
                  onChange={value => setCreditCardDetails(p => ({ ...p, documentType: value }))}
                >
                  {renderIdentificationTypes()}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={18}>
              <p className="title-form">{t('Document number')}</p>
              <Form.Item
                validateStatus={!!errors['doc_number'] && 'error'}
                help={errors['doc_number']}
              >
                <Input
                  id="identification_number"
                  placeholder={t('Document number')}
                  onFocus={() => setCreditCardDetails(p => ({ ...p, focused: 'number' }))}
                  onChange={e => setCreditCardDetails(p => ({ ...p, doc_number: e.target.value }))}
                  value={creditCardDetails.doc_number}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>

      {/* Preview de tarjeta */}
      <Col
        className="card"
        xs={8}
        sm={8}
        md={8}
        lg={8}
        xl={8}
        style={{ paddingLeft: '40px', paddingRight: '40px' }}
      >
        <div className="content-card">
          <Cards
            number={creditCardDetails.number}
            name={creditCardDetails.name}
            expiry={creditCardDetails.expiry}
            cvc={creditCardDetails.cvc}
            focused={creditCardDetails.focused}
            placeholders={cardPlaceholders}
            locale={cardLocale}
          />
        </div>
      </Col>
    </Row>
  );
};

export default CreditCardForm;
